export default __webpack_public_path__ + "media/titles/title_6_locale_de-5d896b84.png";